import { FocusTrap } from '../utils/focus-trap';
import { ScrollbarHelper } from '../utils/scrollbar-helper';

export const SearchModal = () => {
    const modal = document.getElementById('search-modal');
    if (!modal) return;

    const triggers = document.querySelectorAll('[data-search-toggle]');
    const closeBtn = modal.querySelector('[data-search-close]');
    const input = modal.querySelector('[type="text"]');

    const focusTrap = new FocusTrap({ trapElement: modal, autofocus: false });
    const scrollbarHelper = new ScrollbarHelper();

    let lastFocusedTrigger = null;

    const open = (e) => {
        lastFocusedTrigger = e.currentTarget;
        modal.classList.add('is-open');
        modal.removeAttribute('inert');
        modal.setAttribute('aria-hidden', 'false');
        scrollbarHelper.hide();
        requestAnimationFrame(() => {
            focusTrap.activate();
            if (input) input.focus();
        });
    };

    const close = () => {
        focusTrap.deactivate();
        modal.classList.remove('is-open');
        modal.classList.add('is-closing');
        modal.setAttribute('aria-hidden', 'true');

        if (lastFocusedTrigger) {
            lastFocusedTrigger.focus();
            lastFocusedTrigger = null;
        }

        modal.addEventListener('animationend', () => {
            modal.classList.remove('is-closing');
            modal.setAttribute('inert', '');
            scrollbarHelper.reset();
        }, { once: true });
    };

    triggers.forEach((trigger) => trigger.addEventListener('click', open));
    if (closeBtn) closeBtn.addEventListener('click', close);

    modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
    });
};
